import React, { useContext, useEffect } from "react";
import { Container } from "react-bootstrap";
import DataTable from "../../../../components/TableComponent/DataTable";
import ContentData from "../../../../constants/contentFile.json";
import SearchData from "../../../../components/SearchComponent/SearchData";
import RefreshIcon from "../../../../assets/images/refresh.svg";
import PluseIcon from "../../../../assets/images/pluse.svg";
import "./rolePage.css";
import { RoleManageContext } from "../RoleListView";
import NextIcon from "../../../../assets/images/next-icon.svg";
import SuccessAlert from "../../../../components/PopupAlertSuccess/PopupAlert";
import ErrorPopup from "../../../../components/PopupAlertError/PopupAlertError";
import Loader from "../../../../components/Loader/Loader";

const RoleList = () => {
  const {
    roleList,
    pageCount,
    totalPage,
    statusValue,
    setSearchData,
    spinnerStatus,
    onPageChange,
    buttonText,
    deleteRoleManage,
    successPopup,
    successPopupMessage,
    searchData,
    errorPopup,
    errorPopupMessage,
    closeSuccessModal, // success modal close function
    roleManageListShow,
    onChangeSearch, // search on change
    onHandleClose, // error modal close
    addRole,
    permissionAccess,
    isSuperAdmin,
    setErrorPopup,
    roleToLogin,
  } = useContext(RoleManageContext);

  const header = [
    { title: "Role", prop: "name" },
    { title: "Description", prop: "description" },
    { title: "No. of Users", prop: "userCount" },
    { title: "", prop: "action" },
  ];
  useEffect(() => {
    const timeoutID = setTimeout(() => {
      roleManageListShow(pageCount, searchData);
    }, 900);

    return () => clearTimeout(timeoutID);
  }, [searchData, pageCount]);
  return (
    <div className="pageBg">
      <div className="breadCrums boldBreadCrums">
        {ContentData.rolePermissions.pageTitle}
      </div>
      {spinnerStatus && <Loader />}
      <Container>
        <div className="pageTittles-role-list">
          {ContentData.rolePermissions.pageTitle}
        </div>
        <div className="searchAddSection adminRole">
          <div className="searchSection">
            <SearchData
              placeholder={ContentData.rolePermissions.searchData}
              value={searchData}
              onChange={onChangeSearch}
              type="text"
            />
          </div>
          <div className="plusRefreshDtat">
            <div
              className={`addAdmin  ${
                permissionAccess?.add ? "" : "disabledMainButton"
              } `}
              onClick={() => addRole()}
            >
              <img src={PluseIcon} alt="add" />
              {ContentData.rolePermissions.addRole}
            </div>
          </div>
        </div>
        <div className="basicContainer adminTable roleListTable">
          <DataTable
            tableData={roleList}
            header={header}
            onPageChange={(e) => onPageChange(e)}
            isPagination={true}
            currentPage={pageCount}
            pageCount={totalPage}
          />
        </div>
      </Container>
      <ErrorPopup
        show={errorPopup}
        alertMessage={errorPopupMessage}
        buttonText={buttonText}
        status={statusValue}
        handleCancel={() => setErrorPopup(false)}
        handleSubmit={() => {
          if (statusValue === 401 || statusValue === 403) {
            roleToLogin();
            setErrorPopup(false);
          } else {
            setErrorPopup(false);
            roleManageListShow(pageCount, searchData);
          }
        }}
        errorAlertOnly={statusValue === 400 ? true : false}
      />
    </div>
  );
};

export default RoleList;
